<template>
  <div class="p-6 space-y-6">
    <h1 class="text-2xl font-bold flex items-center gap-2">
      My Session Overview
      <BaseInfoIcon :text="ERKLAERUNG.seitenUebersichtStudent" label="My Session Overview" />
    </h1>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="bg-white rounded shadow p-4">
        <p class="text-sm text-gray-500 mb-1">Overall Grade</p>
        <p class="text-2xl font-semibold">{{ formatGrade(overview.overall_grade) }}</p>
      </div>
    </div>

    <div class="bg-white rounded shadow overflow-auto">
      <table class="min-w-full text-sm">
        <thead class="bg-gray-100">
          <tr>
            <th class="text-left px-4 py-3">
              <span class="flex items-center gap-1">
                Session
                <BaseInfoIcon :text="ERKLAERUNG.sessionAufklappen" label="Session aufklappen" :oben="false" fixiert />
              </span>
            </th>
            <th class="text-left px-4 py-3">Weight</th>
            <th class="text-left px-4 py-3">Grade</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in overview.session_grades" :key="item.session_id">
            <tr class="border-t">
              <td class="px-4 py-3">
                <button
                  class="w-full flex items-center gap-2 text-left font-medium rounded px-2 py-1 hover:bg-gray-100 transition-colors"
                  @click="toggleSession(item.session_id)"
                >
                  <ChevronDownIcon v-if="expandedSessionId === item.session_id" class="w-5 h-5 flex-shrink-0" />
                  <ChevronRightIcon v-else class="w-5 h-5 flex-shrink-0" />
                  <span>{{ item.title }}</span>
                </button>
              </td>
              <td class="px-4 py-3">{{ formatGrade(item.weight) }}</td>
              <td class="px-4 py-3">{{ formatGrade(item.grade) }}</td>
            </tr>
            <tr v-if="expandedSessionId === item.session_id" class="bg-gray-50 border-t">
              <td class="px-4 py-3" colspan="3">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
                  <div>
                    <p class="text-gray-500">Evaluation</p>
                    <p class="whitespace-pre-wrap">{{ item.evaluation || "-" }}</p>
                  </div>
                  <div>
                    <p class="text-gray-500">Recommendation</p>
                    <p class="whitespace-pre-wrap">{{ item.recommendation || "-" }}</p>
                  </div>
                  <div>
                    <p class="text-gray-500">Goal</p>
                    <p class="whitespace-pre-wrap">{{ item.goal || "-" }}</p>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>

    <p v-if="errorMessage" class="text-red-600">{{ errorMessage }}</p>
  </div>
</template>

<script>
import { getStudentSessionOverview } from "@/live-sessions/api/usersessions";
import BaseInfoIcon from "@/BaseComponents/BaseInfoIcon.vue";
import { ERKLAERUNG } from "@/async-sessions/erklaerungen";
import { ChevronDownIcon, ChevronRightIcon } from "@heroicons/vue/24/outline";

export default {
  name: "StudentSessionOverview",
  components: {
    BaseInfoIcon,
    ChevronDownIcon,
    ChevronRightIcon,
  },
  data() {
    return {
      ERKLAERUNG,
      overview: {
        overall_grade: null,
        session_grades: [],
      },
      expandedSessionId: null,
      errorMessage: "",
    };
  },
  async mounted() {
    await this.loadOverview();
  },
  methods: {
    formatGrade(value) {
      if (value === null || value === undefined || Number.isNaN(Number(value))) {
        return "-";
      }
      return Number(value).toFixed(2);
    },
    toggleSession(sessionId) {
      this.expandedSessionId = this.expandedSessionId === sessionId ? null : sessionId;
    },
    async loadOverview() {
      this.errorMessage = "";
      try {
        const { data } = await getStudentSessionOverview();
        this.overview = data;
      } catch (error) {
        console.error(error);
        this.errorMessage = "Your session overview could not be loaded.";
      }
    },
  },
};
</script>
